import {
    apiRequest,
    pengalamanKerjaDetail,
    pengalamanKerjaUpdate
} from "../../../../../services/adapters/kepegawaian/pengalamanKerjaService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pengalamanKerjaDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", pengalamanKerjaUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository